<template>
  <div>
    <Menu/>

    <section id="banner" class="my-5">
      <div class="container">
        <div class="row justify-content-center g-0">
          <div class="col-12">
            <div class="banner-section">
              <img v-if="$route.name == 'agents'" src="/images/banner-agents.jpg" class="w-100" />
              <img v-if="$route.name == 'agent'" src="/images/banner-agents-2.jpg" class="w-100" />
              <img v-if="$route.name == 'branches'" src="/images/banner-branches.jpg" class="w-100" />
              <img v-if="$route.name == 'branch'" src="/images/banner-branches-2.jpg" class="w-100" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-if="loading">
      <center>
        <div class="spinner"></div>
        <p><strong>Loading ...</strong></p>
      </center>
    </div>

    <div v-else>
      <section v-if="$route.name == 'branch'">
        <div class="container">
          <div class="row">
            <template v-for="(branch, index) in branchItems">
              <div
                v-if="branch && branch.id == $route.params.branchId"
                :key="index"
                class="col-md-12"
              >
                <center><h1><strong>{{ branch.branch_name }} Branch</strong></h1></center>
                <center><i class="bi bi-envelope-at-fill"></i> {{ branch.email_address }} &nbsp;&nbsp;&nbsp;&nbsp; <i class="bi bi-telephone-plus-fill"></i> {{ branch.telephone_number }}</center>
                <center><i class="bi bi-geo-alt-fill"></i> {{ branch.postal_address }}</center>
                <center>
                  <iframe
                    width="100%"
                    height="450"
                    frameborder="0"
                    style="border:0"
                    :src="'/map.html?lat=' + branch.map_x_position + '&lng=' + branch.map_y_position + '&zoom=12'"
                    allowfullscreen
                  ></iframe>
                </center>
              </div>
            </template>
          </div>
        </div>

        <center><h1>Branch agents</h1></center>
        <div class="row justify-content-center g-3">
          <div
            v-for="agent in branchAgents"
            :key="agent.id"
            class="col-md-2 px-3 m-3 lifestyle-block switch-bg-lgrey h-100 bord-radius agent-card"
          >
            <a
              v-if="agent.cell_number"
              class="agent-whatsapp-side"
              :href="getWhatsappLink(agent)"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="'WhatsApp ' + agent.first_name + ' ' + agent.last_name"
              title="WhatsApp agent"
            >
              <i class="bi bi-whatsapp"></i>
            </a>
            <div class="container">
              <div class="row pt-2">
                <div class="col-md-12 justify-content-center">
                  <router-link :to="'/agents/' + agent.id" :aria-label="'View profile for '+ agent.first_name + ' ' + agent.last_name">
                    <img :src="agent.agent_photo" class="img img-fluid" style="border-radius: 10px;" loading="lazy" decoding="async" @error="logError" />
                  </router-link>
                </div>
                <div class="col-md-12 text-end mb-2">
                  <router-link style="text-decoration: none; font-weight: bold; font-size: 12px; color: #255699;" :to="'/agents/' + agent.id">
                    <strong>View profile</strong>
                  </router-link>
                  <i class="bi bi-box-arrow-up-right"></i>
                </div>
                <div class="col-md-12">
                  <p class="mt-2">
                    <strong>{{ agent.first_name }} {{ agent.last_name }}</strong><br/>
                    <small style="font-size: 12px;">{{ agent.email_address }}<br/>{{ agent.cell_number }}</small>
                  </p>
                  <div class="pb-3">
                    <span style="font-size: 14px;">{{ agent.branch_name ? agent.branch_name : 'National' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="$route.name == 'agent'">
        <div class="container">
          <h1>Agent Profile</h1>
          <div class="row">
            <div v-if="selectedAgent" class="col-md-12 p-3">
              <div class="row pt-2">
                <div class="col-md-3 col-8 p-3">
                  <h2><strong>{{ selectedAgent.first_name }} {{ selectedAgent.last_name }}</strong></h2><br/>
                  <i class="bi bi-envelope-at-fill"></i> {{ selectedAgent.email_address }} <br/>
                  <i class="bi bi-telephone-forward-fill"></i> {{ selectedAgent.cell_number }}
                  <br/>
                  <a
                    v-if="selectedAgent.cell_number"
                    class="agent-profile-whatsapp-link"
                    :href="getWhatsappLink(selectedAgent)"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="bi bi-whatsapp"></i> WhatsApp {{ selectedAgent.first_name }}
                  </a>
                  <br/>
                  <h3>
                    {{ selectedAgent.branch_name ? selectedAgent.branch_name : 'National' }}
                    <span v-if="selectedAgent.branch_province">, {{ selectedAgent.branch_province }}</span>
                  </h3>
                  <button
                    v-if="selectedAgent.email_address"
                    type="button"
                    class="agent-message-button"
                    @click="openMessageDrawer"
                  >
                    <i class="bi bi-envelope"></i> Send a message
                  </button>
                </div>
                <div class="col-md-3 col-4 p-3">
                  <center><img :src="selectedAgent.agent_photo" class="img img-fluid" style="border-radius: 10px;" decoding="async" @error="logError" /></center>
                </div>
                <div class="col-md-6 col-12 p-3">
                  <h3>Resumé</h3>
                  <p v-html="decodeResume(selectedAgent.resume)"></p>
                  <div v-if="selectedAgent.id == '881298'">
                    <p>As a seasoned property specialist in the Garden Route, I do more than assist clients in finding a home; I help them embrace a distinctive lifestyle rooted in natural beauty, tranquillity, and luxury.</p>
                    <p>With over 12 years of experience in the real estate industry and a strong focus on the high-end residential market, I provide strategic guidance and in-depth local knowledge to connect discerning buyers and investors with exceptional properties along South Africa’s most iconic coastline. From beachfront villas and eco-estates to hidden lifestyle retreats, I have a deep understanding of the region’s unique offerings and an eye for matching the right property to the right person.</p>
                    <p>My approach is defined by professionalism, integrity, and personalised service. I understand that buying or selling a home is both a financial and emotional investment, which is why I strive to make every interaction meaningful, every detail considered, and every journey seamless from start to finish.</p>
                    <p>Whether you're relocating, expanding your portfolio, or seeking a lifestyle upgrade, I am committed to delivering a real estate experience that is not only successful but also deeply rewarding.</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-md-12 p-3 text-center">
              <p><strong>Agent not found.</strong></p>
            </div>
          </div>
        </div>

        <div v-if="selectedAgent" class="container pb-5 agent-properties-section">
          <div class="row justify-content-center">
            <div class="col-lg-8 text-center pt-4 pb-3">
              <h2>AVAILABLE PROPERTIES</h2>
              <p>Explore properties currently represented by {{ selectedAgent.first_name }} {{ selectedAgent.last_name }}.</p>
            </div>
          </div>

          <div v-if="listingsLoading" class="text-center py-5">
            <div class="spinner"></div>
            <p class="mt-3"><strong>Loading properties...</strong></p>
          </div>

          <div v-else-if="listingsError" class="text-center py-4">
            <p><strong>We could not load this agent's properties right now.</strong></p>
            <small>{{ listingsErrorMessage }}</small>
          </div>

          <div v-else-if="visibleAgentProperties.length" class="row justify-content-center">
            <div
              v-for="property in visibleAgentProperties"
              :key="property.id"
              class="col-lg-4 col-md-6 mt-3 mb-4"
            >
              <div class="agent-property-card h-100">
                <router-link
                  :to="property.transaction_type === 'rental' ? '/rental/' + property.id : '/property/' + property.id"
                  :aria-label="'View ' + property.marketing_heading"
                  class="agent-property-image-link"
                >
                  <img
                    :src="property.featured_image || '/images/generic.jpg'"
                    :alt="property.marketing_heading || 'Property listing'"
                    class="w-100 force-height agent-property-image"
                    loading="lazy"
                    decoding="async"
                    @error="logError"
                  />
                  <strong><span class="agent-property-price">{{ formatPropertyPrice(property) }}</span></strong>
                  <span class="agent-property-transaction">{{ property.transaction_type === 'rental' ? 'TO RENT' : 'FOR SALE' }}</span>
                </router-link>

                <div class="agent-property-content">
                  <router-link :to="property.transaction_type === 'rental' ? '/rental/' + property.id : '/property/' + property.id" class="agent-property-link">
                    <h3 class="agent-property-title">
                      {{ property.marketing_heading }}
                    </h3>
                  </router-link>
                  <p v-if="property.location" class="agent-property-location">
                    <i class="bi bi-geo-alt-fill"></i> {{ property.location }}
                  </p>
                  <p v-if="property.description" class="agent-property-description">
                    {{ property.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="text-center py-4">
            <p><strong>No properties are currently linked to {{ selectedAgent.first_name }} in the listings response.</strong></p>
          </div>

          <div v-if="agentProperties.length > propertyLimit" class="text-center pb-4">
            <button type="button" class="agent-properties-more" @click="propertyLimit += 6">
              View more properties
            </button>
          </div>
        </div>
      </section>

      <section v-if="$route.name == 'branches'">
        <center><h1>Our branches</h1></center>
        <div class="container">
          <div class="row">
            <div v-for="branch in branchItems" :key="branch.id" class="col-md-4 pb-5">
              <div class="row">
                <div class="col-md-11 bg-light p-3" style="border-radius: 30px; min-height: 250px;">
                  <p><strong>{{ branch.branch_name }} Branch</strong></p>
                  <p><i class="bi bi-geo-alt-fill"></i> {{ branch.province }} - {{ branch.physical_address }}</p>
                  <p><i class="bi bi-telephone-plus-fill"></i> {{ branch.telephone_number }} </p>
                  <router-link style="text-decoration: none; font-weight: bold; font-size: 12px; color: #255699;" :to="'/branches/' + branch.id"><strong>View profile</strong> <i class="bi bi-box-arrow-up-right"></i></router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="$route.name == 'agents'">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-7 text-center mb-3">
              <h1 class="mb-3">OUR TEAM</h1>
              <p>Discover an extraordinary assembly of real estate excellence curated by our team of dedicated professionals. We take pride in presenting an unparalleled selection of properties, showcasing the epitome of luxury living in South Africa.</p>
            </div>
          </div>
          <div class="row justify-content-center mb-3">
            <div class="col-md-6 mb-2">
              <center>
                <label for="globalFilter"><strong>Search</strong> by name or surname</label><br/><br/>
                <input type="text" v-model="globalFilter" class="form-control" id="globalFilter">
              </center>
            </div>
          </div>
          <div class="row">
            <div
              v-for="agent in filteredAgents"
              :key="agent.id"
              class="col-6 col-md-2"
              style="border-radius: 30px;"
            >
              <div class="container-fluid m-2 bg-light agent-card">
                <a
                  v-if="agent.cell_number"
                  class="agent-whatsapp-side"
                  :href="getWhatsappLink(agent)"
                  target="_blank"
                  rel="noopener noreferrer"
                  :aria-label="'WhatsApp ' + agent.first_name + ' ' + agent.last_name"
                  title="WhatsApp agent"
                >
                  <i class="bi bi-whatsapp"></i>
                </a>
                <div class="row pt-2" style="min-height: 450px;">
                  <div class="col-md-12">
                    <router-link :to="'/agents/' + agent.id" :aria-label="'View profile for ' + agent.first_name + ' ' + agent.last_name">
                      <img :src="agent.agent_photo" style="border-radius: 10px;" class="img img-fluid" loading="lazy" decoding="async" @error="logError" />
                    </router-link>
                    <router-link style="text-decoration: none; font-weight: bold; font-size: 12px; color: #255699;" :to="'/agents/' + agent.id"><strong>View profile</strong> <i class="bi bi-box-arrow-up-right"></i></router-link><br/><br/>
                    <p>
                      <strong>{{ agent.first_name }} {{ agent.last_name }}</strong><br/>
                      <small style="font-size: 12px;">{{ agent.email_address }}<br/>{{ agent.cell_number }}</small>
                    </p>
                    <div class="pb-3">
                      <i class="bi bi-geo-alt-fill"></i>
                      <span style="font-size: 14px;">{{ agent.branch_name ? agent.branch_name : 'National' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <transition name="agent-drawer-fade">
      <div
        v-if="messageDrawerOpen && selectedAgent"
        class="agent-message-backdrop"
        @click.self="closeMessageDrawer"
      >
        <aside
          class="agent-message-drawer"
          role="dialog"
          aria-modal="true"
          aria-labelledby="agent-message-title"
        >
          <button
            type="button"
            class="agent-message-close"
            aria-label="Close message form"
            @click="closeMessageDrawer"
          >
            &times;
          </button>

          <div class="agent-message-brand" aria-hidden="true">
            <span>CHAS EVERITT</span>
            <strong>LUXURY</strong>
          </div>

          <h2 id="agent-message-title">SEND A MESSAGE</h2>
          <p>
            Use the form below to send a message directly to
            {{ selectedAgent.first_name }} {{ selectedAgent.last_name }}.
          </p>

          <form class="agent-message-form" novalidate @submit.prevent="submitAgentMessage">
            <div class="form-group">
              <label for="agent-contact-name">Name</label>
              <input
                id="agent-contact-name"
                ref="contactName"
                v-model.trim="contactForm.name"
                type="text"
                class="form-control"
                autocomplete="name"
                maxlength="120"
                required
              />
            </div>

            <div class="form-group">
              <label for="agent-contact-phone">Phone</label>
              <input
                id="agent-contact-phone"
                v-model.trim="contactForm.phone"
                type="tel"
                class="form-control"
                autocomplete="tel"
                maxlength="40"
                required
              />
            </div>

            <div class="form-group">
              <label for="agent-contact-email">Email</label>
              <input
                id="agent-contact-email"
                v-model.trim="contactForm.email"
                type="email"
                class="form-control"
                autocomplete="email"
                maxlength="160"
                required
              />
            </div>

            <div class="form-group">
              <label for="agent-contact-message">Your message</label>
              <textarea
                id="agent-contact-message"
                v-model.trim="contactForm.message"
                class="form-control"
                rows="5"
                maxlength="3000"
                required
              ></textarea>
            </div>

            <div class="agent-contact-honeypot" aria-hidden="true">
              <label for="agent-contact-website">Website</label>
              <input
                id="agent-contact-website"
                v-model="contactForm.website"
                type="text"
                tabindex="-1"
                autocomplete="off"
              />
            </div>

            <div class="form-check agent-message-check">
              <input
                id="agent-contact-terms"
                v-model="contactForm.termsAccepted"
                class="form-check-input"
                type="checkbox"
                required
              />
              <label class="form-check-label" for="agent-contact-terms">
                I have read and accept the
                <a href="/terms" target="_blank" rel="noopener noreferrer">terms and conditions</a>
                and
                <a href="/privacy" target="_blank" rel="noopener noreferrer">privacy policy</a>.
              </label>
            </div>

            <div class="form-check agent-message-check">
              <input
                id="agent-contact-marketing"
                v-model="contactForm.marketingOptIn"
                class="form-check-input"
                type="checkbox"
              />
              <label class="form-check-label" for="agent-contact-marketing">
                I want to receive marketing material.
              </label>
            </div>

            <p v-if="contactSuccess" class="agent-message-status" role="status">
              {{ contactSuccess }}
            </p>
            <p v-if="contactError" class="agent-message-status" role="alert">
              {{ contactError }}
            </p>

            <button
              type="submit"
              class="agent-message-submit"
              :disabled="contactSubmitting || !contactFormValid"
            >
              <span v-if="contactSubmitting">Sending...</span>
              <span v-else>Send</span>
            </button>
          </form>
        </aside>
      </div>
    </transition>

    <a
      v-if="$route.name === 'agent' && selectedAgent && selectedAgent.cell_number"
      class="agent-profile-whatsapp-fixed"
      :href="getWhatsappLink(selectedAgent)"
      target="_blank"
      rel="noopener noreferrer"
      :aria-label="'WhatsApp ' + selectedAgent.first_name + ' ' + selectedAgent.last_name"
      title="WhatsApp agent"
    >
      <span>{{ selectedAgent.first_name }}</span>
      <i class="bi bi-whatsapp"></i>
    </a>

    <Footer/>
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/home/Menu.vue'
import Footer from '@/components/home/Footer.vue'

const AGENTS_API = 'https://luxury-dev.chaseveritt.co.za/api/v3/fetch_agents_localdb.php'
const BRANCHES_API = 'https://luxury-dev.chaseveritt.co.za/api/v3/fetch_branches_localdb.php'
const LISTINGS_API = 'https://luxury-dev.chaseveritt.co.za/api/v3/fetch_listings.php'
const RENTALS_API = 'https://luxury-dev.chaseveritt.co.za/api/v3/fetch_rentals.php'
const AGENT_MESSAGE_API = 'https://luxury-dev.chaseveritt.co.za/api/v3/send_agent_message.php'

export default {
  components: {
    Menu,
    Footer
  },

  data() {
    return {
      listings: [],
      listingsLoading: false,
      listingsLoaded: false,
      listingsError: false,
      listingsErrorMessage: '',
      propertyLimit: 6,
      messageDrawerOpen: false,
      contactSubmitting: false,
      contactSuccess: '',
      contactError: '',
      contactForm: {
        name: '',
        phone: '',
        email: '',
        message: '',
        termsAccepted: false,
        marketingOptIn: false,
        website: ''
      },
      agents: [],
      branches: [],
      loading: true,
      selectedType: null,
      selectedLocations: [],
      minPrice: 0,
      maxPrice: 100000000,
      priceRange: [0, 100000000],
      originalListings: [],
      currentPage: 1,
      itemsPerPage: 12,
      locationSearch: '',
      navigationArray: [],
      globalFilter: ''
    }
  },

  async mounted() {
    if (typeof document !== 'undefined') {
      document.addEventListener('keydown', this.handleAgentMessageEscape)
    }

    this.loading = true

    const agentsRequest = this.fetchAgents()
    const branchesRequest = this.fetchBranches()

    try {
      if (this.$route.name === 'agents' || this.$route.name === 'agent') {
        // Agent pages must not wait for the separate branches request.
        await agentsRequest
        this.loading = false

        if (this.$route.name === 'agent') {
          this.fetchAgentListings()
        }

        await branchesRequest
      } else if (this.$route.name === 'branches') {
        await branchesRequest
        this.loading = false
        await agentsRequest
      } else {
        // A single branch page needs both the branch and its agents.
        await Promise.all([agentsRequest, branchesRequest])
      }
    } catch (error) {
      console.error('Error loading agents page:', error)
    } finally {
      this.loading = false
    }
  },

  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.removeEventListener('keydown', this.handleAgentMessageEscape)
      document.body.classList.remove('agent-message-open')
      document.body.style.overflow = ''
    }
  },

  computed: {
    contactFormValid() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      return Boolean(
        this.selectedAgent &&
        this.selectedAgent.email_address &&
        this.contactForm.name &&
        this.contactForm.phone &&
        emailPattern.test(this.contactForm.email) &&
        this.contactForm.message &&
        this.contactForm.termsAccepted
      )
    },

    branchItems() {
      return Array.isArray(this.branches) ? this.branches : []
    },

    agentItems() {
      return Array.isArray(this.agents) ? this.agents : []
    },

    filteredAgents() {
      const searchString = (this.globalFilter || '').trim().toLowerCase()

      if (!searchString) {
        return this.agentItems
      }

      return this.agentItems.filter(agent => {
        const firstName = agent.first_name || ''
        const lastName = agent.last_name || ''

        return (
          firstName.toLowerCase().includes(searchString) ||
          lastName.toLowerCase().includes(searchString) ||
          `${firstName} ${lastName}`.toLowerCase().includes(searchString)
        )
      })
    },

    selectedAgent() {
      const agentId = String(this.$route.params.agentId || '')

      return this.agentItems.find(agent => String(agent.id) === agentId) || null
    },

    agentProperties() {
      const agentId = String(this.$route.params.agentId || '').trim()

      if (!agentId || !Array.isArray(this.listings)) {
        return []
      }

      return this.listings.filter(property => {
        const listingAgentIds = Array.isArray(property.agent_keys)
          ? property.agent_keys.map(value => String(value).trim())
          : []

        return listingAgentIds.includes(agentId)
      })
    },

    visibleAgentProperties() {
      return this.agentProperties.slice(0, this.propertyLimit)
    },

    branchAgents() {
      const branchId = String(this.$route.params.branchId || '')

      return this.agentItems.filter(agent => {
        return this.getAgentBranchIds(agent).includes(branchId)
      })
    }
  },

  watch: {
    '$route.params.agentId'() {
      this.propertyLimit = 6
      this.closeMessageDrawer()
      this.resetAgentMessageForm()

      if (this.$route.name === 'agent' && !this.listingsLoaded && !this.listingsLoading) {
        this.fetchAgentListings()
      }
    }
  },

  methods: {
    openMessageDrawer() {
      if (!this.selectedAgent || !this.selectedAgent.email_address) {
        return
      }

      this.contactSuccess = ''
      this.contactError = ''
      this.messageDrawerOpen = true

      if (typeof document !== 'undefined') {
        document.body.classList.add('agent-message-open')
        document.body.style.overflow = 'hidden'
      }

      this.$nextTick(() => {
        if (this.$refs.contactName && typeof this.$refs.contactName.focus === 'function') {
          this.$refs.contactName.focus()
        }
      })
    },

    closeMessageDrawer() {
      this.messageDrawerOpen = false

      if (typeof document !== 'undefined') {
        document.body.classList.remove('agent-message-open')
        document.body.style.overflow = ''
      }
    },

    handleAgentMessageEscape(event) {
      if (event && event.key === 'Escape' && this.messageDrawerOpen) {
        this.closeMessageDrawer()
      }
    },

    resetAgentMessageForm() {
      this.contactForm = {
        name: '',
        phone: '',
        email: '',
        message: '',
        termsAccepted: false,
        marketingOptIn: false,
        website: ''
      }
      this.contactError = ''
    },

    async submitAgentMessage() {
      if (this.contactSubmitting || !this.contactFormValid || !this.selectedAgent) {
        return
      }

      this.contactSubmitting = true
      this.contactSuccess = ''
      this.contactError = ''

      try {
        const response = await axios.post(AGENT_MESSAGE_API, {
          agent_id: this.selectedAgent.id,
          name: this.contactForm.name,
          phone: this.contactForm.phone,
          email: this.contactForm.email,
          message: this.contactForm.message,
          terms_accepted: this.contactForm.termsAccepted,
          marketing_opt_in: this.contactForm.marketingOptIn,
          website: this.contactForm.website,
          page_url: typeof window !== 'undefined' ? window.location.href : '',
          enquiry: 'Agent Profile Enquiry',
          receiveMarketing: this.contactForm.marketingOptIn ? 1 : 0,
          utm_sourcc: typeof window !== 'undefined' ? (localStorage.getItem('utm_sourcc') || localStorage.getItem('utm_source') || 'N/A') : 'N/A',
          utm_source: typeof window !== 'undefined' ? (localStorage.getItem('utm_source') || localStorage.getItem('utm_sourcc') || 'N/A') : 'N/A',
          utm_medium: typeof window !== 'undefined' ? (localStorage.getItem('utm_medium') || 'N/A') : 'N/A',
          utm_campaign: typeof window !== 'undefined' ? (localStorage.getItem('utm_campaign') || 'N/A') : 'N/A',
          utm_content: typeof window !== 'undefined' ? (localStorage.getItem('utm_content') || 'N/A') : 'N/A',
          landing_page_url: typeof window !== 'undefined' ? (localStorage.getItem('landing_page_url') || window.location.href) : 'N/A',
          conversion_page_url: typeof window !== 'undefined' ? window.location.href : 'N/A'
        }, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })

        const payload = response && response.data ? response.data : {}

        if (payload.success === false) {
          throw new Error(payload.message || 'The message could not be sent.')
        }

        const successMessage = payload.message ||
          `Your message has been sent to ${this.selectedAgent.first_name}.`
        this.resetAgentMessageForm()
        this.contactSuccess = successMessage
      } catch (error) {
        const responseMessage = error && error.response && error.response.data
          ? error.response.data.message
          : ''

        this.contactError = responseMessage || error.message ||
          'Your message could not be sent. Please try again.'
      } finally {
        this.contactSubmitting = false
      }
    },

    normaliseListingsPayload(payload) {
      let value = payload

      if (typeof value === 'string') {
        try {
          value = JSON.parse(value.replace(/^\uFEFF/, '').trim())
        } catch (error) {
          throw new Error('The listings endpoint did not return valid JSON.')
        }
      }

      const candidates = [
        value,
        value && value.listings,
        value && value.listing,
        value && value.properties,
        value && value.results,
        value && value.items,
        value && value.data && value.data.listings,
        value && value.data && value.data.listing,
        value && value.data && value.data.properties,
        value && value.data && value.data.results,
        value && value.data
      ]

      for (let index = 0; index < candidates.length; index += 1) {
        const candidate = candidates[index]

        if (Array.isArray(candidate)) {
          return candidate.reduce((items, entry) => {
            if (Array.isArray(entry)) {
              return items.concat(entry)
            }

            items.push(entry)
            return items
          }, [])
        }
      }

      for (let index = 0; index < candidates.length; index += 1) {
        const candidate = candidates[index]

        if (candidate && typeof candidate === 'object') {
          const values = Object.keys(candidate).map(key => candidate[key])
          const objectValues = values.filter(item => item && typeof item === 'object')

          if (objectValues.length && objectValues.length === values.length) {
            return objectValues
          }
        }
      }

      return []
    },

    normaliseProperty(item) {
      const source = Array.isArray(item) ? item[0] : item

      if (!source || typeof source !== 'object') {
        return null
      }

      const payload = source.payload && typeof source.payload === 'object'
        ? source.payload
        : source

      // The listings endpoint can wrap the real listing inside a `listing` array.
      // In that response, the outer object may have its own database ID (for
      // example 1115), while the nested listing contains the public property ID
      // used by /property/:id (for example 2596715).
      const nestedListingCandidates = [
        source.payload && source.payload.listing && source.payload.listing.data && source.payload.listing.data.listing,
        payload.listing && payload.listing.data && payload.listing.data.listing,
        source.listing && source.listing.data && source.listing.data.listing,
        source.data && source.data.listing,
        payload.data && payload.data.listing,
        source.listing,
        payload.listing
      ]

      let data = null

      for (let index = 0; index < nestedListingCandidates.length; index += 1) {
        const candidate = nestedListingCandidates[index]

        if (Array.isArray(candidate) && candidate.length && candidate[0] && typeof candidate[0] === 'object') {
          data = candidate[0]
          break
        }

        if (candidate && !Array.isArray(candidate) && typeof candidate === 'object') {
          // The API commonly returns the listing collection as an object such
          // as { "0": { ...listing fields... } } rather than a real array.
          // Unwrap that object before reading agent, listing_type and tags.
          if (candidate['0'] && typeof candidate['0'] === 'object') {
            data = candidate['0']
            break
          }

          const candidateValues = Object.keys(candidate)
            .map(key => candidate[key])
            .filter(value => value && typeof value === 'object' && !Array.isArray(value))

          if (candidateValues.length === 1) {
            data = candidateValues[0]
            break
          }

          // A direct listing object already contains its own listing fields.
          if (
            candidate.agent !== undefined ||
            candidate.agent_2 !== undefined ||
            candidate.agent_3 !== undefined ||
            candidate.listing_type !== undefined ||
            candidate.marketing_heading !== undefined
          ) {
            data = candidate
            break
          }
        }
      }

      if (!data) {
        data = payload.data && !Array.isArray(payload.data) && typeof payload.data === 'object'
          ? payload.data
          : payload
      }

      const listingWrapper = payload.listing && !Array.isArray(payload.listing) && typeof payload.listing === 'object'
        ? payload.listing
        : payload

      // Always prefer the ID from the real nested listing. The outer wrapper ID
      // is an internal row/cache ID and must not be used for the property route.
      const propertyId = this.firstDefinedValue([
        data.id,
        data.property_id,
        data.listing_id,
        data.ref_id,
        data.uuid,
        listingWrapper.property_id,
        listingWrapper.listing_id,
        listingWrapper.ref_id,
        listingWrapper.id,
        payload.property_id,
        payload.listing_id,
        payload.ref_id,
        payload.id,
        source.property_id,
        source.listing_id,
        source.ref_id,
        source.id
      ])

      if (propertyId === null || typeof propertyId === 'undefined' || propertyId === '') {
        return null
      }

      const featuredImage = this.extractPropertyImage([data, listingWrapper, payload, source])
      const suburb = this.firstDefinedValue([
        data.loc_suburb,
        data.suburb,
        data.location_suburb,
        listingWrapper.loc_suburb
      ]) || ''
      const region = this.firstDefinedValue([
        data.loc_region,
        data.region,
        data.city,
        data.location_region,
        listingWrapper.loc_region
      ]) || ''
      const heading = this.firstDefinedValue([
        data.heading,
        data.marketing_heading,
        data.marketing_title,
        data.property_name,
        data.listing_title,
        data.title,
        data.name,
        listingWrapper.heading,
        listingWrapper.marketing_heading,
        listingWrapper.marketing_title,
        listingWrapper.property_name,
        listingWrapper.listing_title,
        listingWrapper.title,
        payload.heading,
        payload.marketing_heading,
        payload.marketing_title,
        payload.property_name,
        payload.title,
        source.heading,
        source.marketing_heading,
        source.marketing_title,
        source.property_name,
        source.title
      ]) || this.buildPropertyTitle(data, listingWrapper, suburb, region)
      const rawDescription = this.firstDefinedValue([
        data.ai_short_description,
        data.ai_long_description,
        data.short_description,
        data.marketing_description,
        data.description,
        listingWrapper.ai_short_description,
        listingWrapper.ai_long_description,
        listingWrapper.description,
        payload.description,
        source.description
      ]) || ''
      const price = this.firstDefinedValue([
        data.price,
        data.listing_price,
        data.amount,
        listingWrapper.price,
        payload.price,
        source.price
      ])
      const transactionValue = this.firstDefinedValue([
        data.sale_or_rental,
        data.transaction_type,
        data.mandate_type,
        data.listing_type,
        data.rental,
        listingWrapper.sale_or_rental,
        listingWrapper.transaction_type,
        listingWrapper.mandate_type,
        listingWrapper.listing_type,
        payload.sale_or_rental,
        payload.transaction_type,
        payload.listing_type,
        source.sale_or_rental,
        source.transaction_type,
        source.listing_type
      ])
      const transactionText = String(transactionValue || '').toLowerCase()
      const rentalTags = [
        data && data.tags,
        listingWrapper && listingWrapper.tags,
        payload && payload.tags,
        source && source.tags,
        payload && payload.listing && payload.listing.tags
      ]
      const isRental =
        transactionText.includes('rent') ||
        transactionText.includes('lease') ||
        transactionText.includes('to let') ||
        transactionText === 'let' ||
        rentalTags.some(tags => tags && this.normaliseBoolean(tags.rent)) ||
        this.normaliseBoolean(data.rental) ||
        this.normaliseBoolean(listingWrapper.rental)
      const poaValue = this.firstDefinedValue([
        data.poa,
        listingWrapper.poa,
        payload.poa,
        source.poa
      ])
      const agentKeys = []

      ;[data, listingWrapper, payload, source].forEach(agentSource => {
        this.collectListingAgentKeys(agentSource, agentKeys)
      })

      return {
        id: String(propertyId),
        featured_image: featuredImage || '/images/generic.jpg',
        marketing_heading: String(heading),
        location: [suburb, region].filter(value => value).join(', '),
        price,
        poa: this.normaliseBoolean(poaValue) || Number(price) === 999999999,
        description: this.truncateText(this.stripHtml(rawDescription), 260),
        transaction_type: isRental ? 'rental' : 'sale',
        transaction_label: isRental ? 'To Rent' : 'For Sale',
        agent_keys: agentKeys
      }
    },

    buildPropertyTitle(data, listingWrapper, suburb, region) {
      const sources = [data || {}, listingWrapper || {}]
      const getValue = keys => {
        for (let sourceIndex = 0; sourceIndex < sources.length; sourceIndex += 1) {
          const source = sources[sourceIndex]

          for (let keyIndex = 0; keyIndex < keys.length; keyIndex += 1) {
            const value = source[keys[keyIndex]]

            if (value !== null && typeof value !== 'undefined' && String(value).trim() !== '') {
              return String(value).trim()
            }
          }
        }

        return ''
      }

      const bedrooms = getValue(['bedrooms', 'beds', 'bedroom_count'])
      const propertyType = getValue([
        'property_type',
        'property_type_name',
        'type',
        'listing_type_name',
        'category'
      ])
      const saleOrRental = getValue([
        'sale_or_rental',
        'transaction_type',
        'mandate_type',
        'listing_type'
      ])
      const location = suburb || region || getValue([
        'loc_suburb',
        'suburb',
        'estate_name',
        'development_name',
        'loc_region',
        'region',
        'city'
      ])

      const parts = []

      if (bedrooms && Number(bedrooms) > 0) {
        parts.push(`${bedrooms} Bedroom`)
      }

      parts.push(propertyType || 'Property')

      const transaction = saleOrRental.toLowerCase()
      if (
        transaction.includes('rent') ||
        transaction.includes('lease') ||
        transaction.includes('to let') ||
        transaction === 'let'
      ) {
        parts.push('to Rent')
      } else {
        parts.push('for Sale')
      }

      if (location) {
        parts.push(`in ${location}`)
      }

      return parts.join(' ')
    },

    firstDefinedValue(values) {
      for (let index = 0; index < values.length; index += 1) {
        const value = values[index]

        if (value !== null && typeof value !== 'undefined' && value !== '') {
          return value
        }
      }

      return null
    },

    extractPropertyImage(sources) {
      const imageFields = [
        'featured_image',
        'featuredImage',
        'main_image',
        'primary_image',
        'image',
        'image_url',
        'photo',
        'thumbnail'
      ]

      for (let sourceIndex = 0; sourceIndex < sources.length; sourceIndex += 1) {
        const source = sources[sourceIndex]

        if (!source || typeof source !== 'object') {
          continue
        }

        for (let fieldIndex = 0; fieldIndex < imageFields.length; fieldIndex += 1) {
          const value = source[imageFields[fieldIndex]]
          const image = this.extractImageValue(value)

          if (image) {
            return image
          }
        }

        const arrays = [
          source.listing_images,
          source.listing_images_hd,
          source.images,
          source.photos,
          source.gallery
        ]

        for (let arrayIndex = 0; arrayIndex < arrays.length; arrayIndex += 1) {
          if (Array.isArray(arrays[arrayIndex]) && arrays[arrayIndex].length) {
            const image = this.extractImageValue(arrays[arrayIndex][0])

            if (image) {
              return image
            }
          }
        }
      }

      return ''
    },

    extractImageValue(value) {
      if (typeof value === 'string' && value.trim()) {
        return value.trim()
      }

      if (value && typeof value === 'object') {
        return value.url || value.src || value.path || value.image_url || value.image || ''
      }

      return ''
    },

    collectListingAgentKeys(value, keys, depth = 0) {
      if (value === null || typeof value === 'undefined' || depth > 5) {
        return
      }

      if (Array.isArray(value)) {
        value.forEach(item => this.collectListingAgentKeys(item, keys, depth + 1))
        return
      }

      if (typeof value !== 'object') {
        return
      }

      Object.keys(value).forEach(key => {
        const fieldValue = value[key]
        const keyName = String(key).toLowerCase()

        if (/(agent|broker|consultant)/.test(keyName)) {
          this.addListingAgentKey(fieldValue, keys)
        }

        if (fieldValue && typeof fieldValue === 'object') {
          this.collectListingAgentKeys(fieldValue, keys, depth + 1)
        }
      })
    },

    addListingAgentKey(value, keys) {
      if (value === null || typeof value === 'undefined' || value === '') {
        return
      }

      if (Array.isArray(value)) {
        value.forEach(item => this.addListingAgentKey(item, keys))
        return
      }

      if (typeof value === 'object') {
        const fullName = [value.first_name, value.last_name].filter(name => name).join(' ')
        ;[
          value.id,
          value.agent_id,
          value.agentId,
          value.email,
          value.email_address,
          value.name,
          value.full_name,
          value.fullname,
          fullName
        ].forEach(item => this.addListingAgentKey(item, keys))
        return
      }

      String(value)
        .split(/[,|;]/)
        .map(item => this.normaliseAgentMatchKey(item))
        .filter(item => item)
        .forEach(item => {
          if (!keys.includes(item)) {
            keys.push(item)
          }
        })
    },

    normaliseAgentMatchKey(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ')
    },

    propertyBelongsToAgent(property, agent) {
      if (!property || !agent || !Array.isArray(property.agent_keys)) {
        return false
      }

      const agentKeys = [
        agent.id,
        agent.agent_id,
        agent.email_address,
        agent.email,
        `${agent.first_name || ''} ${agent.last_name || ''}`.trim()
      ]
        .map(value => this.normaliseAgentMatchKey(value))
        .filter(value => value)

      return property.agent_keys.some(key => agentKeys.includes(key))
    },

    normaliseBoolean(value) {
      if (typeof value === 'boolean') {
        return value
      }

      if (typeof value === 'number') {
        return value === 1
      }

      const normalised = String(value || '').trim().toLowerCase()
      return ['1', 'true', 'yes', 'y'].includes(normalised)
    },

    stripHtml(value) {
      if (!value) {
        return ''
      }

      return String(value)
        .replace(/<br\s*\/?>(?=.)/gi, ' ')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/\s+/g, ' ')
        .trim()
    },

    truncateText(value, limit) {
      const text = String(value || '').trim()

      if (!text || text.length <= limit) {
        return text
      }

      return `${text.slice(0, limit).trim()}...`
    },

    formatPropertyPrice(property) {
      if (!property || property.poa) {
        return 'POA'
      }

      const price = Number(property.price)

      if (!Number.isFinite(price) || price <= 0) {
        return 'Price on request'
      }

      return `R ${price.toLocaleString('en-ZA')}`
    },

    async fetchAgentListings() {
      if (this.listingsLoading || this.listingsLoaded) {
        return
      }

      this.listingsLoading = true
      this.listingsError = false
      this.listingsErrorMessage = ''

      try {
        const requestConfig = {
          headers: {
            Accept: 'application/json'
          }
        }

        // Sales and rentals come from separate API endpoints.
        const [salesResponse, rentalsResponse] = await Promise.all([
          axios.get(LISTINGS_API, requestConfig),
          axios.get(RENTALS_API, requestConfig)
        ])

        const rawSales = this.normaliseListingsPayload(salesResponse.data)
        const rawRentals = this.normaliseListingsPayload(rentalsResponse.data)

        const normalisedSales = rawSales
          .map(item => this.normaliseProperty(item))
          .filter(property => property)

        const normalisedRentals = rawRentals
          .map(item => this.normaliseProperty(item))
          .filter(property => property)
          .map(property => ({
            ...property,
            transaction_type: 'rental',
            transaction_label: 'To Rent'
          }))

        // Merge both feeds and remove duplicate records using the public property ID.
        const uniqueProperties = new Map()

        ;[...normalisedSales, ...normalisedRentals].forEach(property => {
          const key = `${property.transaction_type}:${property.id}`
          uniqueProperties.set(key, property)
        })

        this.listings = Array.from(uniqueProperties.values())
        this.listingsLoaded = true

        console.info('[Agents] Sale listings received:', rawSales.length)
        console.info('[Agents] Rental listings received:', rawRentals.length)
        console.info('[Agents] Properties normalised:', this.listings.length)

        if (rawRentals.length) {
          console.info('[Agents] First raw rental:', rawRentals[0])
        }

        this.$nextTick(() => {
          if (this.selectedAgent) {
            console.info('[Agents] Selected agent:', {
              id: this.selectedAgent.id,
              email: this.selectedAgent.email_address,
              name: `${this.selectedAgent.first_name || ''} ${this.selectedAgent.last_name || ''}`.trim()
            })
            console.info('[Agents] Properties matched to selected agent:', this.agentProperties.length)
          }
        })
      } catch (error) {
        this.listingsError = true
        this.listingsErrorMessage = error && error.message
          ? error.message
          : 'The listings request failed.'
        console.error('Error fetching agent properties:', error)
      } finally {
        this.listingsLoading = false
      }
    },

    getWhatsappLink(agent) {
      if (!agent || !agent.cell_number) {
        return '#'
      }

      let formattedNumber = String(agent.cell_number).replace(/\D/g, '')

      if (formattedNumber.startsWith('00')) {
        formattedNumber = formattedNumber.slice(2)
      }

      if (formattedNumber.startsWith('0')) {
        formattedNumber = `27${formattedNumber.slice(1)}`
      } else if (!formattedNumber.startsWith('27')) {
        formattedNumber = `27${formattedNumber}`
      }

      const firstName = agent.first_name || 'there'
      const profilePath = `/agents/${agent.id}`
      const profileURL = typeof window !== 'undefined'
        ? `${window.location.origin}${profilePath}`
        : `https://luxury-dev.chaseveritt.co.za${profilePath}`
      const message = `Hello ${firstName}, I found your profile on the Chas Everitt Luxury Portfolio website and would like to get in touch: ${profileURL}`

      return `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`
    },

    decodeResume(htmlString) {
      if (typeof htmlString !== 'string') {
        return ''
      }

      const formattedHTML = htmlString.replace(/\n/g, '<br>')

      if (typeof document === 'undefined') {
        return formattedHTML
      }

      const element = document.createElement('div')
      element.innerHTML = formattedHTML

      return element.innerHTML.replace(/â€œ|â€|â€¦|¦|¦/g, '')
    },

    logError(event) {
      event.target.onerror = null
      event.target.src = '/images/generic.jpg'
    },

    normaliseAgents(payload) {
      let rawAgents = []

      if (Array.isArray(payload)) {
        rawAgents = payload
      } else if (payload && Array.isArray(payload.agents)) {
        rawAgents = payload.agents
      }

      return rawAgents
        .map(item => Array.isArray(item) ? item[0] : item)
        .filter(agent => agent && agent.id !== null && typeof agent.id !== 'undefined')
    },

    normaliseBranches(payload) {
      let rawBranches = []

      if (Array.isArray(payload)) {
        rawBranches = payload
      } else if (payload && Array.isArray(payload.branches)) {
        rawBranches = payload.branches
      }

      return rawBranches
        .map(item => Array.isArray(item) ? item[0] : item)
        .filter(branch => branch && branch.id !== null && typeof branch.id !== 'undefined')
    },

    getAgentBranchIds(agent) {
      if (!agent) {
        return []
      }

      const branchIds = []
      const addBranchId = value => {
        if (value === null || typeof value === 'undefined' || value === '') {
          return
        }

        const actualValue = typeof value === 'object' && value.id ? value.id : value

        String(actualValue)
          .split(',')
          .map(id => id.trim())
          .filter(id => id)
          .forEach(id => {
            if (!branchIds.includes(id)) {
              branchIds.push(id)
            }
          })
      }

      const sources = [agent.branch_ids, agent.branches, agent.display_branch]

      sources.forEach(source => {
        if (Array.isArray(source)) {
          source.forEach(addBranchId)
        } else {
          addBranchId(source)
        }
      })

      return branchIds
    },

    updateAgentBranchDetails() {
      if (!this.agentItems.length) {
        return
      }

      const branchLookup = this.branchItems.reduce((lookup, branch) => {
        lookup[String(branch.id)] = branch
        return lookup
      }, {})

      this.agents = this.agentItems.map(agent => {
        const branchIds = this.getAgentBranchIds(agent)
        const matchedBranches = branchIds
          .map(branchId => branchLookup[branchId])
          .filter(branch => branch)

        const branchNames = [...new Set(
          matchedBranches
            .map(branch => branch.branch_name)
            .filter(name => name)
        )]

        const branchProvinces = [...new Set(
          matchedBranches
            .map(branch => branch.province)
            .filter(province => province)
        )]

        return Object.assign({}, agent, {
          branch_ids: branchIds,
          display_branch: agent.display_branch || branchIds[0] || null,
          branch_name: branchNames.length
            ? branchNames.join(', ')
            : (agent.branch_name || ''),
          branch_province: branchProvinces.length
            ? branchProvinces.join(', ')
            : (agent.branch_province || '')
        })
      })
    },

    async fetchBranches() {
      try {
        const response = await axios.get(BRANCHES_API, {
          headers: {
            Accept: 'application/json'
          }
        })

        const branches = this.normaliseBranches(response.data)

        if (branches.length) {
          this.branches = branches
          this.updateAgentBranchDetails()
        }
      } catch (error) {
        console.error('Error fetching branches:', error)
      }
    },

    async fetchAgents() {
      try {
        const response = await axios.get(AGENTS_API, {
          headers: {
            Accept: 'application/json'
          }
        })

        const agents = this.normaliseAgents(response.data)

        if (agents.length) {
          this.agents = agents
          this.updateAgentBranchDetails()
        } else {
          console.warn('The agents endpoint returned no agents:', response.data)
        }
      } catch (error) {
        console.error('Error fetching agents:', error)
      }
    }
  }
}
</script>


<style scoped>
.force-height {
  height: 300px;
  object-fit: cover;
}

.social-links{
  position: unset;
  display: inline;
  float: right;
  margin-right: 20px;
}
/* Scoped keyframes for the spinning animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Spinner class with blue border on top */
.spinner {
  display: inline-block;
  border: 4px solid #f3f3f3; /* Light gray */
  border-top: 4px solid blue; /* Blue top border */
  border-radius: 50%; /* Circular shape */
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite; /* Continuous spinning */
}

.agent-card {
  position: relative;
  overflow: visible;
}

.agent-whatsapp-side {
  position: absolute;
  top: 18px;
  right: -13px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #ffffff;
  color: #0d6efd;
  font-size: 22px;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.agent-whatsapp-side:hover,
.agent-whatsapp-side:focus {
  color: #0d6efd;
  transform: scale(1.08);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.24);
}

.agent-profile-whatsapp-link {
  display: inline-block;
  margin-top: 8px;
  color: #0d6efd;
  font-weight: 700;
  text-decoration: none;
}

.agent-profile-whatsapp-link:hover,
.agent-profile-whatsapp-link:focus {
  color: #0d6efd;
  text-decoration: underline;
}

.agent-profile-whatsapp-fixed {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  border-top-left-radius: 30px;
  background: #efefef;
  color: #0d6efd;
  font-size: 28px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 -2px 14px rgba(0, 0, 0, 0.12);
}

.agent-profile-whatsapp-fixed span {
  font-size: 11px;
  line-height: 1.1;
}

.agent-profile-whatsapp-fixed:hover,
.agent-profile-whatsapp-fixed:focus {
  color: #0d6efd;
}


.agent-message-button,
.agent-properties-more,
.agent-message-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 24px;
  background: #0d6efd;
  color: #ffffff;
  font-weight: 700;
  text-transform: uppercase;
  padding: 10px 24px;
  text-decoration: none;
  cursor: pointer;
}

.agent-message-button:hover,
.agent-message-button:focus,
.agent-properties-more:hover,
.agent-properties-more:focus,
.agent-message-submit:hover,
.agent-message-submit:focus {
  background: #255699;
  color: #ffffff;
}

.agent-message-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.agent-properties-section h2,
.agent-property-title {
  color: #255699;
  font-weight: 800;
}

.agent-property-card {
  height: 100%;
  overflow: hidden;
  border-radius: 18px;
  background: #ececec;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.agent-property-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
}

.agent-property-image-link {
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: 18px 18px 0 0;
}

.agent-property-image {
  display: block;
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 18px 18px 0 0;
  transition: transform 0.35s ease;
}

.agent-property-card:hover .agent-property-image {
  transform: scale(1.02);
}

.agent-property-price {
  position: absolute;
  top: 0;
  left: 46px;
  z-index: 2;
  padding: 11px 20px 12px;
  border-radius: 0 0 18px 18px;
  background: #ffffff;
  color: #255699;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.2px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}

.agent-property-transaction {
  position: absolute;
  right: 12px;
  bottom: 12px;
  left: auto;
  top: auto;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  width: auto;
  height: auto;
  padding: 7px 11px;
  border-radius: 4px;
  background: #255699;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.agent-property-content {
  padding: 18px 16px 20px;
}

.agent-property-link {
  color: inherit;
  text-decoration: none;
}

.agent-property-title {
  margin: 0 0 10px;
  font-size: 20px;
  line-height: 1.1;
  text-transform: uppercase;
}

.agent-property-location {
  color: #255699;
  font-size: 13px;
  font-weight: 700;
}

.agent-property-description {
  margin-bottom: 0;
  font-size: 14px;
  line-height: 1.5;
}

.agent-message-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(255, 255, 255, 0.78);
}

.agent-message-drawer {
  position: absolute;
  top: 0;
  right: 0;
  width: min(520px, 100%);
  height: 100%;
  overflow-y: auto;
  padding: 44px 38px;
  background: #ffffff;
  box-shadow: -12px 0 32px rgba(0, 0, 0, 0.16);
}

.agent-message-close {
  position: absolute;
  top: 12px;
  left: 14px;
  border: 0;
  background: transparent;
  color: #255699;
  font-size: 34px;
  line-height: 1;
  cursor: pointer;
}

.agent-message-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 14px;
  color: #255699;
  letter-spacing: 2px;
}

.agent-message-brand span {
  font-size: 10px;
}

.agent-message-brand strong {
  font-size: 24px;
  font-weight: 500;
}

.agent-message-drawer h2 {
  color: #255699;
  font-weight: 800;
  text-align: center;
}

.agent-message-form .form-group {
  margin-bottom: 12px;
}

.agent-message-form label {
  margin-bottom: 4px;
  font-weight: 600;
}

.agent-message-form .form-control {
  border-color: #c9d6e8;
  border-radius: 8px;
}

.agent-message-form .form-control:focus,
.agent-message-form .form-check-input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.18);
}

.agent-message-check {
  margin: 12px 0;
  font-size: 13px;
}

.agent-message-check a,
.agent-message-status {
  color: #255699;
}

.agent-message-status {
  padding: 10px 12px;
  border-radius: 8px;
  background: #edf4ff;
  font-weight: 700;
}

.agent-contact-honeypot {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.agent-message-submit {
  min-width: 130px;
  margin: 10px auto 0;
}

.agent-message-form {
  display: flex;
  flex-direction: column;
}

.agent-drawer-fade-enter-active,
.agent-drawer-fade-leave-active {
  transition: opacity 0.2s ease;
}

.agent-drawer-fade-enter,
.agent-drawer-fade-leave-to {
  opacity: 0;
}

@media (max-width: 767px) {
  .agent-message-drawer {
    padding: 42px 20px 28px;
  }

  .agent-property-title {
    font-size: 18px;
  }

  .agent-whatsapp-side {
    top: 12px;
    right: -8px;
    width: 38px;
    height: 38px;
    font-size: 20px;
  }

  .agent-profile-whatsapp-fixed {
    padding: 11px 14px;
    font-size: 24px;
  }
}



.agent-property-image-link {
  position: relative;
  display: block;
}

</style>
